import { HandCoins, Award, Search, Sparkles, Truck, Trash2 } from "lucide-react";

export const CATEGORY_LABELS = {
  financing: "Mortgage & Financing", real_estate_agent: "Real Estate Agent", inspections: "Home Inspection",
  cleaning: "Cleaning Services", moving: "Moving Companies", junk_removal: "Junk Removal",
};
export const CATEGORY_ICONS = {
  financing: HandCoins, real_estate_agent: Award, inspections: Search, cleaning: Sparkles, moving: Truck, junk_removal: Trash2,
};
export const CATEGORY_DEFAULT_CTA = {
  financing: "Get Pre-Qualified", real_estate_agent: "Contact Agent", inspections: "Schedule Inspection",
  cleaning: "Book a Cleaning", moving: "Get a Quote", junk_removal: "Get a Quote",
};
export const CATEGORY_BANNER_EYEBROW = {
  financing: "Featured Lender", real_estate_agent: "Premier Agent", inspections: "Featured Inspector",
  cleaning: "Featured Cleaner", moving: "Featured Mover", junk_removal: "Featured Partner",
};
export const LISTING_STATUS_LABELS = { coming_soon: "Coming Soon", active: "For Sale", pending: "Pending", sold: "Sold", off_market: "Off Market" };
export const HOA_PERIOD_LABELS = { Monthly: "/mo", Quarterly: "/qtr", Annually: "/yr" };
